<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">处方统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span>院中管理统计</span>|
					<span style="color: #699ce4;">处方统计</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>入院时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.depId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;">机构
							<el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in orgList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i class="icon-export" style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">
					<el-table-column prop="depName" label="科室" width="180"></el-table-column>
					<el-table-column prop="medication" label="用药处方"></el-table-column>
					<el-table-column prop="food" label="饮食处方"></el-table-column>
					<el-table-column prop="sports" label="运动处方"></el-table-column>
					<el-table-column prop="psychology" label="心理处方"></el-table-column>
					<el-table-column prop="sleep" label="睡眠处方"></el-table-column>
					<el-table-column prop="chineseMedicine" label="中医处方"></el-table-column>
					<el-table-column prop="total" label="处方总数"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';

	export default {
		mixins: [mixin],
		data() {
			return {
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null,
					summary: []
				},
				filter: {
					inHospitalDataStart: '',
					inHospitalDataEnd: '',
					depId: '',
					orgId:'',
					pageNumber: 1,
					pageSize: 10,
					date:[]
				},
				deptList: [],
				permission: false,
				orgList:[]
			}
		},
		created() {
			if(this.$route.query.depId){
				this.filter.depId = +this.$route.query.depId;
			}
			let query = this.$route.query;

			if (query.dateStart && query.dateEnd) {
				this.filter.inHospitalDataStart = dayjs(query.dateStart).format('YYYY-MM-DD 00:00:00')
				this.filter.inHospitalDataEnd = dayjs(query.dateEnd).format('YYYY-MM-DD 23:59:59');
				this.filter.date = [this.filter.inHospitalDataStart, this.filter.inHospitalDataEnd];
			}else{
				const now = dayjs();
				const firstDayOfMonth = dayjs().startOf('month');
				this.filter.inHospitalDataStart = firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss');
				this.filter.inHospitalDataEnd=now.format('YYYY-MM-DD HH:mm:ss');
				this.filter.date=[this.filter.inHospitalDataStart,this.filter.inHospitalDataEnd];
			}
			this.loadList();
			// 获取 科室下拉
			api.getDeptDropdown({
				departmentType: 0
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			})
			// 获取机构下拉
			api.getListComboboxOrg().then((res)=>{
				if(res.code==1000){
					this.orgList=res.data;
				} else {
					this.$message.error(res.message)
				}
			})
		},
		methods: {
			async loadList() {
				this.isLoading = true;
				let res = await api.getPrescriptionReportList(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.code == 1000 && res.data) {
					this.list.summary = ['合计', res.data.sum.sum.medication, res.data.sum.sum.food, res.data.sum.sum
						.sports, res.data.sum.sum.psychology, res.data.sum.sum.sleep, res.data.sum.sum
						.chineseMedicine, res.data.sum.sum.total
					];
					this.list.data = res.data.list.list;
				}
				// 权限控制
				this.user = JSON.parse(localStorage.getItem('user')).data;
				this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
				this.isLoading = false;
			},
			getSummaries() {
				this.$nextTick(() => {
					this.$refs['multipleTable'].doLayout();
				});
				return this.list.summary;
			},
			// 过滤条件 更改
			handleFilter(key, val) {
				switch (key) {
					case 0:
						if (this.filter.date) {
							this.filter.inHospitalDataStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.inHospitalDataEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.inHospitalDataStart = '';
							this.filter.inHospitalDataEnd = '';
						}
						break;
				}
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			exportReport() {
				this.filter.pageSize=this.list.total;
				let url = api.exportStatisticPrescriptionReport(this.filter);
				const tempLink = document.createElement('a');
				tempLink.style.display = 'none';
				tempLink.href = url;
				tempLink.target = '_blank';
				document.body.appendChild(tempLink);
				tempLink.click()
				document.body.removeChild(tempLink);
			this.filter.pageSize=10;

			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
</style>